import React, { useState } from 'react'
import { Card } from 'react-bootstrap'
import BarChart from './BarChart'
import { CallesCalado } from '../../../config/graficos'
import { toast } from 'react-toastify'
import { Button } from '@material-ui/core'
import { connect } from 'react-redux'
import * as actions from '../actions'
import { FORM_PROCESO_CALADO } from '../../../config/forms'
import { reduxForm, formValueSelector } from 'redux-form'
import { COLORES } from '../../../config/colores'

function EstadoCallesDeCalado (props) {
  const { data, calificacionCalles, calle } = props

  const [calleCalado, setCalleCalado] = useState('')
  const [cerealCalleDeCalado, setCerealCalleDeCalado] = useState('')
  const [capacidadOcupadaCalle, setCapacidadOcupadaCalle] = useState(0)

  const changeForm = () => {
    const { change: formChange, cpa } = props
    const capacidadMaxima = 10

    if (calleCalado !== '') {
      if (capacidadOcupadaCalle < capacidadMaxima) {
        if (cerealCalleDeCalado === cpa.claveCereal || cerealCalleDeCalado === 'null' || capacidadOcupadaCalle === 0) {
          if (!(cerealCalleDeCalado === cpa.claveCereal)) {
            props.updateCerealCalleDeCalado(calleCalado, cpa.claveCereal)
          }
          formChange('calle', calleCalado && calleCalado)
          props.handleClose()
        } else {
          toast.error('La calle seleccionada no coincide con el cereal.')
        }
      } else {
        toast.error('La calle seleccionada tiene toda su capacidad ocupada.')
      }
    } else {
      props.handleClose()
    }
  }

  const width = props.width
  const height = props.height
  const x2 = width - 130

  const setCalleDeCalado = (newCalle, cerealNewCalle, capacidadNewCalle) => {
    if (newCalle) {
      setCalleCalado(newCalle)
    }
    setCerealCalleDeCalado(cerealNewCalle)
    setCapacidadOcupadaCalle(capacidadNewCalle)
  }

  return (
    <>
      <div className='container-info-calles'>
        <Card className='card-calle-seleccion-calado'>
          <Card.Header style={{ backgroundColor: '#707070', color: '#ffffff', fontSize: '1.2rem' }} >Calle sugerida </Card.Header>
          <Card.Text style={{ fontSize: '2.5rem', color: '#818181' }}>{calle}</Card.Text>
        </Card>
        <Card className='card-calle-seleccion-calado'>
          <Card.Header style={{ backgroundColor: '#707070', color: '#ffffff', fontSize: '1.2rem' }}>Calle seleccionada </Card.Header>
          <Card.Text style={{ fontSize: '2.5rem', color: '#818181' }}>{calleCalado}</Card.Text>
        </Card>
      </div>
      {(data) && <div className='container-barchart'>
        <BarChart
          className='barchart-calles-calado'
          width={width}
          height={height}
          data={data}
          calificacionCalles={calificacionCalles}
          options={CallesCalado}
          xRange={[0, x2]}
          yRange={[350, 0]}
          setCalleDeCalado={setCalleDeCalado}
        />
      </div>
      }
      {(!data) && <span><div className='loader' /></span>}
      <div className='container-btn-chart'>
        <Button
          style={{ margin: '8px auto', backgroundColor: COLORES.grey.dark, color: '#ffffff' }}
          onClick={props.handleClose}
          size='medium'
          variant='contained'
        >
            Cancelar
        </Button>

        <Button
          style={{ margin: '8px auto', color: '#ffffff' }}
          onClick={changeForm}
          size='medium'
          color='primary'
          variant='contained'
        >
            Confirmar
        </Button>
      </div>
    </>
  )
}

const selector = formValueSelector(FORM_PROCESO_CALADO)

const mapStateToProps = (state) => {
  return {
    calle: selector(state, 'calle'),
    cpa: state.camionesIngreso.consultaCpa
  }
}

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_PROCESO_CALADO,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false,
  updateUnregisteredFields: true
})

export default withRedux(withReduxForm(EstadoCallesDeCalado))
